module.exports = __webpack_public_path__ + "img/house-chimney-heart.8aa0cc44.svg";